import { useState } from 'react';

import { Button } from '@/components/design-system/Button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/design-system/popover';
import { useNotifications } from '@/features/notifications/hooks/useNotifications';
import type { Notification } from '@/features/notifications/types/Notifications.types';
import { BellOutlined } from '@ant-design/icons';

import { NotificationsList } from './NotificationsList';

export const NotificationsDropdown: React.FC = () => {
  const { notifications, hasUnreadNotifications, markAsRead, markAllAsRead } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);

  const handleNotificationClick = (notification: Notification) => {
    // TODO: Integrate with actual routing system when available
    markAsRead(notification.id);

    if (notification.actionLink) {
      // eslint-disable-next-line no-console
      console.log('Navigate to:', notification.actionLink);
    }
    setIsOpen(false);
  };

  const handleMarkAllAsRead = () => {
    markAllAsRead();
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <div className="relative">
          <Button
            variant="icon"
            className="text-md hover:bg-secondary-400 flex h-8 w-8 items-center justify-center rounded-full p-5"
          >
            <BellOutlined className="h-4 w-4" />
          </Button>
          {hasUnreadNotifications && (
            <div className="bg-notification-500 absolute top-2.5 right-2.5 h-2 w-2 rounded-full" />
          )}
        </div>
      </PopoverTrigger>

      <PopoverContent className="bg-secondary nav-scrollbar-collapsed mt-4 w-[320px] rounded-lg p-0" align="center">
        <NotificationsList
          notifications={notifications}
          onNotificationClick={handleNotificationClick}
          onMarkAllAsRead={handleMarkAllAsRead}
        />
      </PopoverContent>
    </Popover>
  );
};
